// Next relative zone id: one past the highest label already on the field.
// Behavior-zone "new zone" ids come from the class picker, not from here.
export function nextFreeZoneId(labels: readonly number[]): number {
  let max = 0;
  for (const label of labels) if (label > max) max = label;
  return max + 1;
}
